import React, { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { getPagePartSlug } from '@gov-nx/module/page/definitions/PageMap';
import AuthorizedRoute from '../../routes/AuthorizedRoute';

const EPeticePage = lazy(() =>
	import('./EPetitionListPage').then(({ EPetitionListPage }) => ({
		default: EPetitionListPage,
	}))
);
const EPetitionDetailPage = lazy(() =>
	import('./EPetitionDetailPage').then(({ EPetitionDetailPage }) => ({
		default: EPetitionDetailPage,
	}))
);
const EPetitionNewPage = lazy(() =>
	import('./EPetitionNewPage').then(({ EPetitionNewPage }) => ({
		default: EPetitionNewPage,
	}))
);
const EPetitionEditPage = lazy(() =>
	import('./EPetitionEditPage').then(({ EPetitionEditPage }) => ({
		default: EPetitionEditPage,
	}))
);

export const getPetitionRoutes = (): RouteObject[] => [
	{
		path: getPagePartSlug('epetice'),
		children: [
			{
				index: true,
				element: (
					<AuthorizedRoute>
						<EPeticePage />
					</AuthorizedRoute>
				),
			},
			{
				path: getPagePartSlug('epetice.zalozeni'),
				element: (
					<AuthorizedRoute>
						<EPetitionNewPage />
					</AuthorizedRoute>
				),
			},
			{
				path: getPagePartSlug('epetice.detail'),
				children: [
					{
						index: true,
						element: (
							<AuthorizedRoute>
								<EPetitionDetailPage />
							</AuthorizedRoute>
						),
					},
					{
						path: getPagePartSlug('epetice.detail.editace'),
						element: (
							<AuthorizedRoute>
								<EPetitionEditPage />
							</AuthorizedRoute>
						),
					},
				],
			},
		],
	},
];
